export const RESET = 'EXSBBATCHNUMBER_LIST_RESET'
export const SET_ITEMS = 'EXSBBATCHNUMBER_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBBATCHNUMBER_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBBATCHNUMBER_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBBATCHNUMBER_LIST_TOGGLE_LOADING'
